export default "__VITE_ASSET__DooCh065__"